import S from 'string'
import { tkRegions, tkDate } from '@moke/vue-tk'
import dayjs from 'dayjs'
import businessTitle from './businessTitle'
function field (value, model) {
  if (!model) return ''
  if (typeof value === 'undefined' || value === null) {
    return model.type === 'Boolean' ? '否' : ''
  }
  if (model.type === 'Date') {
    let date = value.iso ? value.iso : value
    return dayjs(date).format('YYYY-MM-DD HH:mm')
  } else if (model.type === 'String') {
    if (typeof value === 'string') {
      return value.substr(0, 20)
    } else {
      return value
    }
  } else if (model.type === 'Html') {
    return S(value).stripTags().s.substr(0, 20)
  } else if (model.type === 'Boolean') {
    return value ? '是' : '否'
  } else if (model.type === 'Region') {
    return tkRegions.getFullName(value)
  } else if (model.type === 'Select') {
    if (model.items && model.items[value]) {
      return model.items[value]
    } else {
      return ''
    }
  } else if (model.type === 'Pointer') {
    if (value.type === 'Pointer') {
      return ''
    }
    let display = model.cls.display ? model.cls.display : 'objectId'
    let val = value[display]
    return field(val, model.cls.fields[display])
  } else if (model.type === 'GeoPoint') {
    return `经度：${value.longitude}, 纬度：${value.latitude}`
  } else if (model.type === 'Array') {
    let length = value ? value.length : 0
    return model.note + '(' + length + ')'
  } else if (model.type === 'Object') {
    if (!value) return ''
    return value[model.display] ? value[model.display] : '--'
  }
  return value
}
export default {
  fromNow (value) {
    return tkDate(value).fromNow()
  },
  iconOfFileType (value) {
    if (/image/.test(value)) {
      return 'photo'
    } else {
      return 'insert_drive_file'
    }
  },
  field (value, model) {
    return field(value, model)
  },
  businessTitle (value) {
    return businessTitle[value] || '--'
  },
  day (value) {
    if (!value) return ''
    let date = value.iso ? value.iso : value
    return dayjs(date).format('YYYY-MM-DD')
  },
  month (value) {
    if (!value) return ''
    let date = value.iso ? value.iso : value
    return dayjs(date).format('YYYY年MM月')
  },
  date (value) {
    if (!value) return ''
    let date = value.iso ? value.iso : value
    return dayjs(date).format('YYYY-MM-DD HH:mm')
  },
  region (id) {
    return tkRegions.getFullName(id)
  },
  sum (arr, name) {
    let sum = 0
    if (arr) {
      arr.forEach(i => {
        sum += parseFloat(i[name])
      })
    }
    return sum
  }
}
